import { User } from '@auth0/auth0-react';
import { createContext, useContext } from 'react';
import { AuthUser } from '../../../types/users';
import { Client } from '@app/core/types/client';

export interface AuthData {
  readonly user: AuthUser;
  readonly client: Client | null;
}

/** Partial user fields that can be updated in the auth context (e.g. after profile/settings save). */
export type UpdateUserData = Partial<Pick<AuthUser, 'name' | 'surname' | 'language'>>;

export interface AuthContextValue {
  auth0User: User;
  auth: AuthData;

  /** Updates the current user in auth context. Use after saving profile/settings so the UI reflects new data. */
  updateAuthUser: (updates: UpdateUserData) => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuthContext(): AuthContextValue {
  const ctx = useContext(AuthContext);

  if (!ctx) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }

  return ctx;
}
